import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "Here we describe stepwise how to design a listening experiment. Such an experiment is usually created in order to check a hypothesis, which is based on an initial observeration. Each step requires decisions of the experiment designer.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 3,
      rowsSize: [1, 4, 2],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "<b>How to ask the participants about their perception</b>",
                  formatter: "html",
                  scrollbars: false,
                },
              },
              styles: {
                fontSize: "18px",
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/02/23/principle/principle-5-content.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "hint",
                options: {
                  data:
                    "Defining appropriate questions and appropriate scales is an important step and should be thoroughly planned, and ideally, also be pre-tested. Depending on the type of experiment, the suitability of the chosen scale varies - a different scale also leads to a different quality of collected data and impact the evaluation of the experiment.",
                  size: "large-thin",
                  color: "primary",
                  direction: "row",
                },
              },
              styles: {
                padding: "1% 0 4% 0",
                maxWidth: "70%",
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
